import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 401 - 淡出图片
 */

export default class EventDisposePic extends EventBase {
  /**
   * 淡出图片构造函数
   */
  constructor() {
    super()
    this.Parameter = ['1', '', '']
  }

  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[1] || ''
  }
  set Description(value) {
    this.Parameter![1] = value.toString()
  }
  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.DisposePic

  /**
   * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
   * @returns 事件描述信息
   */
}
